/**
 * WEB-808 — suppress the event-page social card until the social feature is
 * actually complete. Flip to `true` to re-mount `SocialDualStateCard` on
 * `/event/[slug]` and resume `fetchEventSocial`.
 *
 * Re-enable only when every WEB-816 prerequisite is true:
 * - going-count is not structurally zero on live events
 * - circles / friends-going is shipped and populated
 * - crowd-fit signals are real API data, not empty placeholders
 * - one-tap RSVP on the card is the supported path
 * - anon copy no longer pitches unbuilt capability
 *
 * Grep target: `EVENT_SOCIAL_CARD_ENABLED`.
 *
 * Call sites read `isEventSocialCardEnabled()` so tests can isolate enabled
 * vs disabled without `skipIf` on this constant.
 */
export const EVENT_SOCIAL_CARD_ENABLED = false;

export function isEventSocialCardEnabled(): boolean {
  return EVENT_SOCIAL_CARD_ENABLED;
}
